<div class="layout-row layout-align-start-center full-height">

  <app-bringoz-date-picker *ngIf="!timeOnly" class="margin-right-10"
                       [date]="timeConfig.from.date"
                       [placeholder]="'Date'"
                       [minDate]="minDate"
                       [maxDate]="maxDate"
                       [isRequired]="isRequired"
                       [isDisabled]="isDisabled"
                       (onChange)="onFromDateChange($event)">
  </app-bringoz-date-picker>

  <div class="layout-row layout-align-start-center">

    <app-bringoz-time-select class="margin-left-10"
                         [selectedTime]="timeConfig.from.value"
                         [ticksInMinutes]="15"
                         [min]="min"
                         [max]="timeConfig.to.value"
                         [placeholder]="'Start Time'"
                         (onSelect)="onFromTimeChange($event)">

    </app-bringoz-time-select>

    <app-bringoz-time-select class="margin-left-10"
                         [selectedTime]="timeConfig.to.value"
                         [min]="timeConfig.from.value"
                         [max]="max"
                         [ticksInMinutes]="15"
                         [placeholder]="'End Time'"
                         (onSelect)="onToTimeChange($event)">

    </app-bringoz-time-select>
  </div>

</div>
